const CENTS_PER_DOLLAR = 100;

/**
 * A price as a customer reads it: "$49", "$49.50", "$1,250". Whole dollars drop
 * the cents; anything else keeps both digits, so a published $49.50 is never
 * rounded into a different promise.
 * @param {number} cents The price in cents.
 * @returns {string} The price in US dollars.
 */
const formatPriceCents = (cents: number): string => {
  const wholeDollars = cents % CENTS_PER_DOLLAR === 0,
    fractionDigits = wholeDollars ? 0 : 2;
  return (cents / CENTS_PER_DOLLAR).toLocaleString("en-US", {
    currency: "USD",
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    style: "currency",
  });
};

export { formatPriceCents };
